import clsx from "clsx";

export function BulletSteps({
	steps,
	selectedIndex,
	navRef,
}: {
	steps: {
		id: string;
		name: string;
	}[];
	selectedIndex: number;
	navRef?: boolean;
}) {
	return (
		<nav
			className={clsx(
				navRef ? "jF-mb-3" : "jF-mb-0",
				"jF-text-[--jF-theme-accent] jF-flex jF-items-center jF-justify-center"
			)}
			aria-label="Progress"
		>
			{steps.map((step, index) => (
				<p
					key={step.id}
					className="!jF-pb-0 jF-text-[--theme-accent] jF-text-sm jF-font-medium jF-leading-4"
				>
					{index < selectedIndex ? "" : index === selectedIndex ? step.name : ""}
				</p>
			))}
			<ol
				role="list"
				className="!jF-mb-0 jF-ml-5 jF-mr-5 jF-flex jF-items-center jF-space-x-3 sm:jF-space-x-5 sm:jF-ml-8"
			>
				{steps.map((step, index) => (
					<li key={step.id} className="!jF-list-none !jF-pb-0">
						{index < selectedIndex ? (
							<button
								className="jF-block jF-h-2.5 jF-w-2.5 jF-rounded-full jF-bg-[--jF-theme-color] jF-hover:bg-[--jF-hover-color]"
								aria-label={step.name}
							>
								<span className="jF-sr-only"></span>
							</button>
						) : index === selectedIndex ? (
							<button
								className="jF-relative jF-flex jF-items-center jF-justify-center"
								aria-label={step.name}
								aria-current="step"
							>
								<span
									className="jF-absolute jF-flex jF-h-5 jF-w-5 jF-p-px"
									aria-hidden="true"
								>
									<span className="jF-h-full jF-w-full jF-rounded-full jF-bg-[--jF-bullet-bg]" />
								</span>
								<span
									className="jF-relative jF-block jF-h-2.5 jF-w-2.5 jF-rounded-full jF-bg-[--jF-theme-color]"
									aria-hidden="true"
								/>
								<span className="jF-sr-only"></span>
							</button>
						) : (
							<button
								className="jF-block jF-h-2.5 jF-w-2.5 jF-rounded-full jF-bg-gray-200 hover:jF-bg-gray-400"
								aria-label={step.name}
							>
								<span className="jF-sr-only"></span>
							</button>
						)}
					</li>
				))}
			</ol>
		</nav>
	);
}
